module.exports = __webpack_public_path__ + "static/media/gcash-word.4bd42180.svg";